<p-table [value]="filteredStatements?.content" [scrollable]="true">
    <ng-template pTemplate="header">
        <tr>
            <th pSortableColumn="invoiceNumber" class="p-py-3" style="width: 140px">
                <div class="p-d-flex p-ai-center">
                    <div>
                        Invoice Number
                    </div>
                    <div>
                        <p-sortIcon field="invoiceNumber"></p-sortIcon>
                    </div>
                </div>
            </th>

            <th pSortableColumn="billToPartyName" style="width: 150px">
                <div class="p-d-flex p-ai-center">
                    <div>
                        Bill to
                    </div>
                    <div>
                        <p-sortIcon field="billToPartyName"></p-sortIcon>
                    </div>
                </div>
            </th>

            <th pSortableColumn="transportDocument" style="width: 130px">
                <div class="p-d-flex p-ai-center">
                    <div>
                        Transport Document
                    </div>
                    <div>
                        <p-sortIcon field="transportDocument"></p-sortIcon>
                    </div>
                </div>
            </th>

            <th pSortableColumn="invoiceDate" style="width: 140px">
                <div class="p-d-flex p-ai-center">
                    <div>
                        Invoice Date
                    </div>
                    <div>
                        <p-sortIcon field="invoiceDate"></p-sortIcon>
                    </div>
                </div>
            </th>

            <th pSortableColumn="dueDate" style="width: 140px">
                <div class="p-d-flex p-ai-center">
                    <div>
                        Due Date
                    </div>
                    <div>
                        <p-sortIcon field="dueDate"></p-sortIcon>
                    </div>
                </div>
            </th>

            <th style="width: 120px">
                <div pSortableColumn="invoiceCurrency" class="p-d-flex p-ai-center">
                    <div>
                        Invoice Currency
                    </div>
                    <div>
                        <p-sortIcon field="invoiceCurrency"></p-sortIcon>
                    </div>
                </div>
            </th>

            <th pSortableColumn="formattedInvoiceAmount" style="width: 130px">
                <div class="p-d-flex p-ai-center">
                    <div>
                        Amount
                    </div>
                    <div>
                        <p-sortIcon field="formattedInvoiceAmount"></p-sortIcon>
                    </div>
                </div>
            </th>

            <th pSortableColumn="formattedTransactionalAmount" style="width: 130px">
                <div class="p-d-flex p-ai-center">
                    <div>
                        Transaction Amount
                    </div>
                    <div>
                        <p-sortIcon field="formattedTransactionalAmount"></p-sortIcon>
                    </div>
                </div>
            </th>

            <th pSortableColumn="formattedDueAmount" style="width: 120px">
                <div class="p-d-flex p-ai-center">
                    <div>
                        Due
                    </div>
                    <div>
                        <p-sortIcon field="formattedDueAmount"></p-sortIcon>
                    </div>
                </div>
            </th>
            <th pSortableColumn="status" style="width: 130px">
                <div class="p-d-flex p-ai-center">
                    <div>
                        Status
                    </div>
                    <div>
                        <p-sortIcon pSortableColumn="status"></p-sortIcon>
                    </div>
                </div>
            </th>

            <th style="width: 30px">
            </th>
        </tr>
    </ng-template>

    <ng-template pTemplate="body" let-statement>
        <tr class="divider-bottom">
            <td style="width: 140px" [class]="platform.SAFARI ? 'p-text-wrap-safari' : 'p-text-wrap'"
                class="p-py-4 p-text-bold">{{statement?.invoiceNumber ? statement?.invoiceNumber : '-'}}</td>
            <td style="width: 150px" [class]="platform.SAFARI ? 'p-text-wrap-safari' : 'p-text-wrap'">{{statement?.billToPartyName ? statement?.billToPartyName : '-'}}</td>
            <td [class]="platform.SAFARI ? 'p-text-wrap-safari' : 'p-text-wrap'" style="width: 130px">{{statement?.transportDocument ? statement?.transportDocument : '-'}}</td>
            <td [class]="platform.SAFARI ? 'p-text-wrap-safari' : 'p-text-wrap'" style="width: 140px">{{statement?.invoiceDate ? (statement?.invoiceDate | date: 'dd-MMM-yyyy') : '-'}}</td>
            <td [class]="platform.SAFARI ? 'p-text-wrap-safari' : 'p-text-wrap'" style="width: 140px">{{statement?.dueDate ? (statement?.dueDate | date:'dd-MMM-yyyy') : '-'}}</td>
            <td [class]="platform.SAFARI ? 'p-text-wrap-safari' : 'p-text-wrap'" style="width: 120px">{{statement?.invoiceCurrency ? statement?.invoiceCurrency : '-'}}</td>
            <td [class]="platform.SAFARI ? 'p-text-wrap-safari' : 'p-text-wrap'" style="width: 130px">{{statement?.formattedInvoiceAmount ? statement?.formattedInvoiceAmount : '-'}}</td>
            <td [class]="platform.SAFARI ? 'p-text-wrap-safari' : 'p-text-wrap'"  style="width: 130px">{{statement?.formattedTransactionalAmount ? statement?.formattedTransactionalAmount : '-'}}</td>

            <td [class]="platform.SAFARI ? 'p-text-wrap-safari' : 'p-text-wrap'" style="width: 120px">{{statement?.formattedDueAmount ? statement?.formattedDueAmount : '-'}}</td>

            <td [class]="statement?.status === 'Unpaid' ? 'p-text-danger' : 'p-text-warning'"
                style="width: 130px">{{statement?.status ? statement?.status : '-'}}</td>

            <td style="width: 30px"><img class="p-cursor"
                                         src="assets/branding/shared-icons/view.svg"
                                         alt=""
                                         style="height: 1.3rem;"
                                         (click)="handleClickActions('view-document', statement)"></td>
        </tr>
    </ng-template>
</p-table>
